// extracted by mini-css-extract-plugin
export default {"rippleEffect":"FormModal_rippleEffect__srRX2","icon":"FormModal_icon__yX-5o","modalForm":"FormModal_modalForm__YCe5b","scrollableModalForm":"FormModal_scrollableModalForm__QwfPm"};